<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @add="add"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                @del="del"
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="ENG_WI_USER"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
                @lct="editInfo"
        ></wTable>
        <!--<el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_type" :label="$t('getapi[6270]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[6267]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="user_name" :label="$t('getapi[3139]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_remind" :label="$t('getapi[6271]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[409]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[734]')"></el-table-column>
            <el-table-column show-overflow-tooltip fixed="right"  :label="$t('getapi[6048]')" width="60">
                <template slot-scope="scope" >
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope)"  type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
                </template>
            </el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ENG_WI_USER" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[497]')" queryData="ENG_WI_USER" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="isShowEdit" :title="$t('getapi[34]')" width="50%" :close-on-click-modal="false">
            <!--<el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="100px" label-position="left" size="small">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6270]')"><el-input v-model="dataDetail.ITEM_TYPE"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6267]')"><el-input v-model="dataDetail.ITEM_NAME"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[3139]')">
                                    <el-input  type="text" v-model="dataDetail.USER_NAME"
                                               readonly
                                               size="mini"
                                               class="mcolor"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectEmployee()"></i>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6271]')"><el-input v-model="dataDetail.ITEM_Remind"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[143]')"><el-input v-model="dataDetail.REMARK"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[410]')"><el-input v-model="dataDetail.CREATE_PERSON" :disabled="true"></el-input></el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[409]')"><el-date-picker v-model="dataDetail.CREATE_TIME" type="datetime" size="mini"
                                                                                         style="width:100%" :disabled="true"></el-date-picker></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[733]')"><el-input v-model="dataDetail.MODIFY_PERSON" :disabled="true"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[734]')"><el-date-picker v-model="dataDetail.MODIFY_TIME" type="datetime" size="mini"
                                                                                         style="width:100%" :disabled="true"></el-date-picker></el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>-->
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[6270]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.ITEM_TYPE"></el-input>
                        </td>
                        <td>{{$t('getapi[6267]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.ITEM_NAME"></el-input>
                        </td>
                        <td>{{$t('getapi[3139]')}}</td>
                        <td>
                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                            <el-input  type="text" v-model="dataDetail.USER_NAME"
                                       readonly
                                       size="mini"
                                       class="mcolor"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectEmployee()"></i>
                            </el-input>
                            </routejump>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6271]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.ITEM_Remind"></el-input>
                        </td>
                        <td>{{$t('getapi[143]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.REMARK"></el-input>
                        </td>
                        <td>{{$t('getapi[410]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.CREATE_PERSON" :disabled="true"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[409]')}}</td>
                        <td>
                            <el-date-picker v-model="dataDetail.CREATE_TIME" type="datetime" size="mini"
                                            style="width:100%" :disabled="true"></el-date-picker>
                        </td>
                        <td>{{$t('getapi[733]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.MODIFY_PERSON" :disabled="true"></el-input>
                        </td>
                        <td>{{$t('getapi[734]')}}</td>
                        <td>
                            <el-date-picker v-model="dataDetail.MODIFY_TIME" type="datetime" size="mini"
                                            style="width:100%" :disabled="true"></el-date-picker>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowEdit = false" size="mini">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="save" :loading="loading" :disabled="loading" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <!--人员-->
        <selector :isVisible="false" :isBatch=false :selectType="9" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getEmployee" ref="employee"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'wi&iiexecuter',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('wi&iiexecuter'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData:[],
                selectIDData: [],
                btn: {
                    edit: false,
                },
                isShowEdit: false,
                dataDetail: {
                    IsEdit: 1,
                    Exclusively_id: 0,
                    ITEM_TYPE: '',
                    ITEM_NAME: '',
                    USER_NUM: '',
                    USER_NAME: '',
                    ITEM_Remind: '',
                    CREATE_PERSON: '',
                    CREATE_TIME: '',
                    MODIFY_PERSON: '',
                    MODIFY_TIME: '',
                    REMARK: ''
                },
                oldDataDetail:[],
                scrollTop:0,
            };
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.authority();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ENG_WI_USER', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[497]"),this.$t("getapi[18]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv2', 356, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 356, 1) == 2) {
                    if (that.$limits.authority('plv3', 356,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 356,1) == 1) {
                        that.btn.edit = true
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 356, 1) == 2) {
                        that.btn.edit = true
                        //删除级
                        if(that.selectData.length > 0 ){
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,del');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                        }
                    }
                }
                //只读权
                that.btnauthority()
            },
            btnauthority(){
                let that = this
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('wi&iiexecuter',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ENG_WI_USER');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Eng/WIView/GetWIIUserView', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndexs)
                    });
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Eng/WIView/GetWIIUserViewToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ENG_WI_USER",
                    fromname: that.$t('getapi[497]'),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            handleSelectionChange(val){
                let that = this;
                that.selectIDData = '';
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].exclusively_id + ',';
                    that.selectData.push(val[i])
                }
                that.authority()
            },
            del(){
                let that = this
                let ids = that.selectIDData.substring(0,that.selectIDData.length -1)
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            ids: ids
                        }
                        that.$http.urlpost('/Eng/WIView/DeleteENGWIUSERByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            editInfo(row){
                let that = this
                that.isShowEdit = true
                that.dataDetail.IsEdit = 0
                that.dataDetail.Exclusively_id = row.row.exclusively_id
                that.dataDetail.ITEM_TYPE = row.row.item_type
                that.dataDetail.ITEM_NAME = row.row.item_name
                that.dataDetail.USER_NUM = row.row.user_num
                that.dataDetail.USER_NAME = row.row.user_name
                that.dataDetail.ITEM_Remind = row.row.item_remind
                that.dataDetail.CREATE_PERSON = row.row.create_person
                that.dataDetail.CREATE_TIME = row.row.create_time
                that.dataDetail.MODIFY_PERSON = row.row.modify_person
                that.dataDetail.MODIFY_TIME = row.row.modify_time
                that.dataDetail.REMARK = row.row.remark
                that.oldDataDetail = JSON.stringify(that.dataDetail)
            },
            // 新增
            add() {
                let that = this;
                that.isShowEdit = true;
                let datetime = Common.methods.getDatetime()
                that.dataDetail = {
                    IsEdit: 1,
                    Exclusively_id: 0,
                    ITEM_TYPE: '',
                    ITEM_NAME: '',
                    USER_NUM: '',
                    USER_NAME: '',
                    ITEM_Remind: '',
                    CREATE_PERSON: that.user,
                    CREATE_TIME: datetime,
                    MODIFY_PERSON: '',
                    MODIFY_TIME: '',
                    REMARK: ''
                };
            },
            save(){
                let that = this
                let parm = []
                parm.push(that.dataDetail)
                that.$http.urlpost('/Eng/WIView/SaveENGWIUSER', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowEdit = false
                        that.getView()
                    }
                });
            },
            selectEmployee(){
                let that = this;
                that.$refs.employee.clearInput(true);
            },
            getEmployee(data){
                let that = this
                console.log(data)
                that.dataDetail.USER_NUM = data.code
                that.dataDetail.USER_NAME = data.name
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isShowEdit = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isShowEdit = false
                    callback(true)
                }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 5px!important;
    }
</style>
